import { useAuth } from "oidc-react";
import { useNavigate } from "react-router";
import useSWR from "swr";
import { request } from "../utils/request";

export const useCustomers = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  return useSWR(auth?.userData?.access_token ? "customers/all" : null, async () => {
    const dms = await request<any>(`${import.meta.env.VITE_CLUBAPPAPIURL}/appsites`, {
      token: auth.userData?.access_token,
      onUnauthorized: () => navigate("/unauthorized"),
    });

    return dms.data ? dms.data.filter((d) => d.statsActive) : [];
  });
};
